import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { MenuComponent } from "./menu/menu.component";
import { HomeComponent } from "./home/home.component";
import { HomeListResolver } from "./home/home.resolver";
import { PdfComponent } from "./home/pdf/pdf.component";
import { AdminGuard } from "./core/auth/admin.guard";

const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "home",
    canActivate: [AdminGuard],
    component: MenuComponent,
    children: [
      {
        path: "",
        component: HomeComponent,
        resolve: {
          homeList: HomeListResolver,
        },
      },
    ],
  },

  {
    path: "a",
    component: PdfComponent,
  },

  {
    path: "configuracoes",
    canActivate: [AdminGuard],
    loadChildren: () =>
      import("./configuracoes/configuracoes.module").then(
        (m) => m.ConfiguracoesModule
      ),
  },

  {
    path: "captacao",
    canActivate: [AdminGuard],
    loadChildren: () =>
      import("./home/dados-form/dados-form.module").then(
        (m) => m.DadosFormModule
      ),
  },

  {
    path: "coletor",
    canActivate: [AdminGuard],
    loadChildren: () =>
      import("./home/coletor/coletor.module").then((m) => m.ColetorModule),
  },

  {
    path: "alterar-senha",
    canActivate: [AdminGuard],
    loadChildren: () =>
      import("./configuracoes/configuracoes.module").then(
        (m) => m.ConfiguracoesModule
      ),
  },
  {
    path: "esqueci-senha",
    loadChildren: () =>
      import("./esqueci-senha/esqueci-senha.module").then(
        (m) => m.EsqueciSenhaModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
